<template>
  <stage-card-info-list>
    <template #header>
      <div class="d-flex align-center">
        AI Insights
        <insights-help />
      </div>
    </template>
    <template #content>
      <bubble-info-list-item
        v-if="showEstimatedRemaining"
        :bubble-text="estRemainingRelevant"
      >
        Estimated Remaining Relevant
      </bubble-info-list-item>
      <stage-card-info-list-item>
        Recommendation
        <template #append>
          <screening-advice-status-item class="ml-2" :state="state" />
        </template>
      </stage-card-info-list-item>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from './StageCardInfoList';
import StageCardInfoListItem from './StageCardInfoListItem';
import BubbleInfoListItem from './BubbleInfoListItem';
import InsightsHelp from './InsightsHelp';
import ScreeningAdviceStatusItem from '@/components/ReviewSummary/ScreeningAdviceStatusItem';
import { Review } from '@/models';
import { ScreeningAdviceState } from '@/enums';

export default {
  name: 'InsightsInfoList',
  components: {
    StageCardInfoList,
    StageCardInfoListItem,
    BubbleInfoListItem,
    ScreeningAdviceStatusItem,
    InsightsHelp,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    state() {
      if (this.review.isScreeningComplete()) {
        return ScreeningAdviceState.COMPLETE;
      }
      if (this.review.shouldStopScreening()) {
        return ScreeningAdviceState.STOP;
      }
      return ScreeningAdviceState.CONTINUE;
    },
    showEstimatedRemaining() {
      return !this.review.isScreeningComplete();
    },
    estRemainingRelevant() {
      const analysis = this.review.remainingRelevantAnalysis;
      if (!analysis) return '-';

      const { upperRangeCount, lowerRangeCount } = analysis.total;
      if (lowerRangeCount > 0) {
        return `${upperRangeCount.toLocaleString()} - ${lowerRangeCount.toLocaleString()}`;
      }
      return upperRangeCount;
    },
  },
};
</script>
